import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {BehaviorSubject} from 'rxjs';
import {MenuSuperiorService} from './menu-superior.service';
import {ProfileWidgetComponent} from "./components/profile-widget/profile-widget.component";
import {Usuario} from "../../../../app-core/model/cadastros/usuario.model";
import {LoginService} from "../../../../app-core/service/login.service";
import {DeprecatedSharedUtilsModule} from '../../../../app-core/utils/deprecated-shared-utils-module';
import {UiModule} from '../../../../app-core/utils/ui/ui.module';
import {MenuItem} from 'primeng/api';

@Component({
    selector: 'menu-superior',
    templateUrl: './menu-superior.component.html',
    imports: [
        DeprecatedSharedUtilsModule,
        ProfileWidgetComponent,
        UiModule,
    ],
    styleUrls: ['./menu-superior.scss']
})
export class MenuSuperiorComponent implements OnInit {
    usuario: Usuario;
    items$ = new BehaviorSubject<MenuItem[]>([]);

    links = [
        {
            titulo: 'Perfil',
            corpo: 'Edite as informações do seu perfil',
            rota: 'perfil',
            icon: 'fas fas fa-user-alt'
        }
    ];

    constructor(
        public route: Router,
        public loginService: LoginService,
        public menuLateralService: MenuSuperiorService
    ) {
    }

    ngOnInit(): void {
        this.usuario = this.loginService.getUser();
        this.menuLateralService.items.subscribe((items) => {
            this.items$.next(items);
        });
    }

    getUserHasPermission(permissions?: string[]): boolean {
        if (!permissions || permissions.length === 0) {
            return true;
        }

        return !!this.loginService.getUser().roles
            .find((p) => permissions.includes(p));
    }

    navigateTo(route: string) {
        this.route.navigate([route]).then();
    }

    isRouteActive(route: string): boolean {
        return (this.route.url.endsWith(route)) || (this.route.url.endsWith(route + '/'));
    }
}
